import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import "../../styles/otpverify.css";
import {useNavigate } from "react-router-dom";
import{FaTruck} from "react-icons/fa"
// Redux
import { connect } from "react-redux";
import Logo from '../../images/light_- vertical.png'
// actions
// here - loginUser,
import {
  userCheck,
  apiError,
  socialLogin,
  checkUserSuccess,
  checkUserMobile
} from "../../store/actions";

const Login = (props) => {
  const navigate = useNavigate();
  // handleValidSubmit
  const handleValidSubmit = (event, values) => {
    props.loginUser(values, props.history);
  };

  const signIn = (res, type) => {
    const { socialLogin } = props;
    if (type === "google" && res) {
      const postData = {
        name: res.profileObj.name,
        email: res.profileObj.email,
        token: res.tokenObj.access_token,
        idToken: res.tokenId,
      };
      socialLogin(postData, props.history, type);
    } else if (type === "facebook" && res) {
      const postData = {
        name: res.name,
        email: res.email,
        token: res.accessToken,
        idToken: res.tokenId,
      };
      socialLogin(postData, props.history, type);
    }
  };

  //handleGoogleLoginResponse
  const googleResponse = (response) => {
    signIn(response, "google");
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //handleFacebookLoginResponse
  const facebookResponse = (response) => {
    signIn(response, "facebook");
  };

  let focusStatus = false;
  const [isFocused, setIsFocused] = useState(focusStatus);
  const [mobno, setMobno] = useState("");
  const [otp, setOtp] = useState("");
  const [loginMsg, setLoginMsg] = useState("");
  const handleFocus = () => {
    setIsFocused(true);
  };
  const inputStyle = `border-2 rounded py-2 px-2 w-60 caret-blue-500 ${
    isFocused ? "border-green-600" : "border-green-600"
  }`;

  const role = "Manager";

  const handleLogin = async () => {
    let reqObj = {
      mobile: mobno,
      user_type: role,
    };

    await props.userCheck(reqObj);
  };

  useEffect(() => {
    console.log(props.isUserFound,"Anss");
   
    if (props.isUserFound) {
      let obj = {
        mobile: mobno,
      };
      props.checkUserMobile(obj);
      console.log(`/otp/${mobno}`);
      navigate(`/otp/${mobno}`);
      // navigate("/dashboard/tours/bookings")
      
    } else {
      
      
    }
  }, [props.isUserFound]);

  return (
    <main className="auth-shell">
      <section className="auth-hero" aria-label="GoodMove logistics manager platform">
        <div className="auth-hero__orb auth-hero__orb--one" />
        <div className="auth-hero__orb auth-hero__orb--two" />

        <div className="auth-hero__content">
          <div className="auth-hero__badge">
            <span />
            Intelligent logistics operations
          </div>
          <h1>Move every operation with absolute clarity.</h1>
          <p>
            Monitor bookings, trips, drivers, vehicles, settlements and live
            movement from one connected control centre.
          </p>

          <div className="auth-hero__metrics" aria-label="Platform capabilities">
            <div>
              <strong>Live</strong>
              <span>Fleet visibility</span>
            </div>
            <div>
              <strong>360°</strong>
              <span>Operations view</span>
            </div>
            <div>
              <strong>24×7</strong>
              <span>Manager access</span>
            </div>
          </div>
        </div>
      </section>

      <section className="auth-panel">
        <div className="auth-card">
          <div className="auth-card__brand">
            <img src={Logo} alt="GoodMove" />
            <span>Manager Console</span>
          </div>

          <div className="auth-card__heading">
            <span className="auth-card__kicker">WELCOME BACK</span>
            <h2>Sign in to continue</h2>
            <p>Use your registered manager mobile number.</p>
          </div>

          <div className="auth-form">
            <label htmlFor="manager-mobile">Mobile number</label>
            <div className="auth-input-wrap">
              <span className="auth-country-code">+91</span>
              <input
                id="manager-mobile"
                type="tel"
                name="mobile"
                placeholder="Enter 10-digit number"
                maxLength={10}
                inputMode="numeric"
                autoComplete="tel"
                value={mobno}
                onChange={(e) => setMobno(e.target.value)}
                onFocusCapture={handleFocus}
              />
            </div>

            <button
              type="button"
              onClick={handleLogin}
              className="auth-primary-button"
            >
              Continue securely
              <span aria-hidden="true">→</span>
            </button>

            {props.message && (
              <div className="auth-message" aria-live="polite">
                {props.message}
              </div>
            )}
          </div>

          <div className="auth-card__security">
            <span className="auth-card__security-icon">✓</span>
            <span>
              <strong>OTP protected access</strong>
              <small>Your account is verified before every new session.</small>
            </span>
          </div>
        </div>

        <p className="auth-footer-copy">
          GoodMove Logistics Operations Platform
        </p>
      </section>
    </main>
  );
};

const mapStateToProps = (state) => {
  const { error, isUserFound,message } = state.Login;
  return { error, isUserFound,message };
};
// here -- loginUser,
export default connect(mapStateToProps, {
  userCheck,
  apiError,
  socialLogin,
  checkUserMobile
  // checkUserSuccess,
})(Login);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
};

// import PropTypes from "prop-types";
// import React, { useState, useEffect } from "react";
// import "../../styles/otpverify.css";
// import {useNavigate } from "react-router-dom";
// import{FaTruck} from "react-icons/fa"
// // Redux
// import { connect } from "react-redux";
// import Logo from '../../images/light_- vertical.png'
// // actions
// // here - loginUser,
// import {
//   userCheck,
//   apiError,
//   socialLogin,
//   checkUserSuccess,
//   checkUserMobile
// } from "../../store/actions";

// const Login = (props) => {
//   const navigate = useNavigate();
//   // handleValidSubmit
//   const handleValidSubmit = (event, values) => {
//     props.loginUser(values, props.history);
//   };

//   const signIn = (res, type) => {
//     const { socialLogin } = props;
//     if (type === "google" && res) {
//       const postData = {
//         name: res.profileObj.name,
//         email: res.profileObj.email,
//         token: res.tokenObj.access_token,
//         idToken: res.tokenId,
//       };
//       socialLogin(postData, props.history, type);
//     } else if (type === "facebook" && res) {
//       const postData = {
//         name: res.name,
//         email: res.email,
//         token: res.accessToken,
//         idToken: res.tokenId,
//       };
//       socialLogin(postData, props.history, type);
//     }
//   };

//   //handleGoogleLoginResponse
//   const googleResponse = (response) => {
//     signIn(response, "google");
//   };

//   //handleTwitterLoginResponse
//   // const twitterResponse = e => {}

//   //handleFacebookLoginResponse
//   const facebookResponse = (response) => {
//     signIn(response, "facebook");
//   };

//   let focusStatus = false;
//   const [isFocused, setIsFocused] = useState(focusStatus);
//   const [mobno, setMobno] = useState("");
//   const [otp, setOtp] = useState("");
//   const [loginMsg, setLoginMsg] = useState("");
//   const handleFocus = () => {
//     setIsFocused(true);
//   };
//   const inputStyle = `border-2 rounded py-2 px-2 w-60 caret-blue-500 ${
//     isFocused ? "border-green-600" : "border-green-600"
//   }`;

//   const role = "Manager";

//   const handleLogin = async () => {
//     let reqObj = {
//       mobile: mobno,
//       user_type: role,
//     };

//     await props.userCheck(reqObj);
//   };

//   useEffect(() => {
//     console.log(props.isUserFound,"Anss");
   
//     if (props.isUserFound) {
//       let obj = {
//         mobile: mobno,
//       };
//       props.checkUserMobile(obj);
//       console.log(`/otp/${mobno}`);
//       navigate(`/otp/${mobno}`);
//       // navigate("/dashboard/tours/bookings")
      
//     } else {
      
      
//     }
//   }, [props.isUserFound]);

//   return (
//     <React.Fragment>
//       <div className="loginContainer" 
//       style={{display:"flex", flexDirection:"column",justifyContent:"center",alignItems:"center"}}
//       >
//         {/* <Logo /> */}
//             <div className="logo_icon">
//               <img src={Logo} alt="LOGO" />
//             </div>

//             <div className="login">

//             <h1
//               className="mt-12 mb-5 text-xl font-medium font-rubik"
//               style={{ textAlign: "center", marginTop: "20px" }}
//             >
//               Login
//             </h1>
//             <div className="mb-3 text-sm font-rubik font-normal">
//               Enter Mobile Number
//             </div>
//             <label className="text-sm font-rubik font-normal"></label>
//             <input
//               type="text"
//               name="mobile"
//               placeholder="Enter Mob Number"
//               maxLength={10}
//               style={{ width: "200px" }}
//               onChange={(e) => setMobno(e.target.value)}
//               className={inputStyle}
//               onFocusCapture={handleFocus}
//             />

//             <button
//               onClick={handleLogin}
//               className="w-60 h-10 bg-emerald-500 rounded text-white font-rubik font-medium drop-shadow-lg"
//               style={{ marginTop: "2%" }}
//             >
//               LOGIN
//             </button>
//             {/* <Otpverify mobile={mobno}/> */}

//             <div className="font-rubik font-medium text-[12px] text-[#FF0000] font-rubik-message">
//               {props.message}
//             </div>

              
//             </div>
              
//       </div>

      

//       <div className="comments">
//         {/*
//      <MetaTags>
//           <title>Login | Skote - React Admin & Dashboard Template</title>
//         </MetaTags>
//       <div className="home-btn d-none d-sm-block">
//         <Link to="/" className="text-dark">
//           <i className="fas fa-home h2" />
//         </Link>
//       </div>
//       <div className="account-pages my-5 pt-sm-5 bg-gray-200">
//         <Container>
//           <Row className="justify-content-center">
//             <Col md={8} lg={6} xl={5}>
//               <Card className="overflow-hidden">
//                 <div className="bg-primary bg-soft">
//                   <Row>
//                     <Col xs={7}>
//                       <div className="text-primary p-4">
//                         <h5 className="text-primary">Welcome Back !</h5>
//                         <p>Sign in to continue to Skote.</p>
//                       </div>
//                     </Col>
//                     <Col className="col-5 align-self-end">
//                       <img src={profile} alt="" className="img-fluid" />
//                     </Col>
//                   </Row>
//                 </div>
//                 <CardBody className="pt-0">
//                   <div>
//                     <Link to="/" className="auth-logo-light">
//                       <div className="avatar-md profile-user-wid mb-4">
//                         <span className="avatar-title rounded-circle bg-light">
//                           <img
//                             src={logo}
//                             alt=""
//                             className="rounded-circle"
//                             height="34"
//                           />
//                         </span>
//                       </div>
//                     </Link>
//                   </div>
//                   <div className="p-2">
//                     <AvForm
//                       className="form-horizontal"
//                       onValidSubmit={(e, v) => {
//                         handleValidSubmit(e, v)
//                       }}
//                     >
//                       {props.error && typeof props.error === "string" ? (
//                         <Alert color="danger">{props.error}</Alert>
//                       ) : null}

//                       <div className="mb-3">
//                         <AvField
//                           name="mobile"
//                           label="Mobile"
//                           className="form-control"
//                           placeholder="Enter Mobile Number"
//                           type="number"
//                           required
//                         />
//                       </div>

//                       <div className="mb-3">
//                         <AvField
//                           name="password"
//                           label="Password"
//                           type="password"
//                           required
//                           placeholder="Enter Password"
//                         />
//                       </div>

//                       <div className="form-check">
//                         <input
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customControlInline"
//                         />
//                         <label
//                           className="form-check-label"
//                           htmlFor="customControlInline"
//                         >
//                           Remember me
//                         </label>
//                       </div>

//                       <div className="mt-3 d-grid">
//                         <button
//                           className="btn btn-primary btn-block"
//                           type="submit"
//                         >
//                           Log In
//                         </button>
//                       </div>

                      

//                       <div className="mt-4 text-center">
//                         <Link to="/forgot-password" className="text-muted">
//                           <i className="mdi mdi-lock me-1" />
//                           Forgot your password?
//                         </Link>
//                       </div>
//                     </AvForm>
//                   </div>
//                 </CardBody>
//               </Card>
//               <div className="mt-5 text-center">
//                 <p>
//                   Don&#39;t have an account ?{" "}
//                   <Link
//                     to="register"
//                     className="fw-medium text-primary"
//                   >
//                     {" "}
//                     Signup now{" "}
//                   </Link>{" "}
//                 </p>
//                 <p>
//                   © {new Date().getFullYear()} Skote. Crafted with{" "}
//                   <i className="mdi mdi-heart text-danger" /> by Themesbrand
//                 </p>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//                       </div> */}
//       </div>
//     </React.Fragment>
//   );
// };

// const mapStateToProps = (state) => {
//   const { error, isUserFound,message } = state.Login;
//   return { error, isUserFound,message };
// };
// // here -- loginUser,
// export default connect(mapStateToProps, {
//   userCheck,
//   apiError,
//   socialLogin,
//   checkUserMobile
//   // checkUserSuccess,
// })(Login);

// Login.propTypes = {
//   error: PropTypes.any,
//   history: PropTypes.object,
//   loginUser: PropTypes.func,
//   socialLogin: PropTypes.func,
// };
